import './instagram_dm_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.InstagramUnsupportedDMContent extends Monitoring.Models.SocialContents.InstagramDMContent
  getMainText: ->
    I18n.t('monitoring.dashboard.social_content.unsupported_format')
